import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as serversApi from '@/api/servers.api';

const serversKey = ['servers'] as const;

/**
 * The test server's containers and the Grafana stack (refreshed every 30 seconds: the stack takes a minute to come up)
 */
export function useServers() {
  return useQuery({
    queryKey: serversKey,
    queryFn: serversApi.getServers,
    staleTime: 10 * 1000,
    refetchInterval: 30 * 1000,
  });
}

export function useGrafanaStack() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ action, hours }: { action: 'up' | 'down'; hours?: number }) => serversApi.grafanaStack(action, hours),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: serversKey }),
  });
}
